import Vue from 'vue';
import Router from 'vue-router';
import AuthenticationService from '@/services/api/authentication/authentication-service';
import LicensingService from '@/services/api/licensing/licensing-service';

Vue.use(Router);

const checkForAuth = (to, from, next) => {
  if (to.query.session) {
    localStorage.setItem('session', to.query.session);
  }
  if (process.env.NODE_ENV && process.env.NODE_ENV === 'local' && ((from.query && from.query.authenticate === 'false') || (to.query && to.query.authenticate === 'false'))) {
    return next();
  }
  AuthenticationService.authenticated(to.params.syncguid).then(result => {
    if (result.isAuthenticated) {
      if (result.isPreview) return next();
      return LicensingService.checkContentAccess(to.params.billingid, to.params.syncguid).then(res => {
        if (res) return next();
        next({ name: 'access-denied' });
      });
    } else {
      const billingid = to.params.billingid;
      next({ name: 'signin', params: { billingid }, query: { redirect: `${window.location.origin}${to.fullPath}` } });
    }
  }).catch(() => {
    next({ name: 'access-denied' });
  });
};

export default new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
      name: 'list-data',
      path: '/courses/list',
      component: () => import('@/views/List.vue'),
    },
    {
      name: 'loading-page',
      path: '/Courses/Launch',
      component: () => import('@/views/LoadingPage.vue'),
    },
    {
      name: 'content-profile',
      path: '/Custom/:standard/:billingid/:syncguid',
      component: () => import('@/views/ContentProfile.vue'),
      beforeEnter: checkForAuth,
    },
    {
      name: 'signin',
      path: '/Auth/:billingid/SignIn',
      component: () => import('@/views/authentication/SignIn.vue'),
    },
    {
      name: 'request-auth',
      path: '/Auth/SAML2/:syncguid/RequestAuth',
      component: () => import('@/views/authentication/SAML2RequestAuth.vue'),
    },
    {
      name: 'consume-auth',
      path: '/:env/auth/saml2/:syncguid/consume',
      component: () => import('@/views/authentication/Consume.vue'),
    },
    {
      name: 'access-denied',
      path: '/denied',
      component: () => import('@/views/AccessDenied.vue'),
    },
    {
      name: 'no-authentication',
      path: '/NoAuthentication',
      component: () => import('@/views/authentication/NoAuthentication.vue'),
    },
  ],
});
